export default __webpack_public_path__ + "static/media/gameplay-icon-9.b77e626f.gif";